<template>
  <div class="credits">
    <section class="headtop">
      <div class="container">
        <div class="col-sm-9 right-border">
          <h1>
            Finishing
          </h1>
          <br>
          <RunButtons />
        </div>
        <div class="col-sm-3">
          <CovidStatus />
        </div>
        <div class="clearfix" />
      </div>
    </section>

    <div class="container lessons">
      <div class="row">
        <div class="text-body col-md-8">
          <p>
            Congratulation you have made it to the end of the 10 year simulation period!
            Now that you’ve reached 2030 and made your choices for the region, you have two options which you can select from the buttons below.
          </p>
        </div>
      </div>
    </div>

    <div class="widget bottom-widget">
      <div class="container">
        <div class="row">
          <div class="text-body col-md-6">
            <!-- {{ currentRun.getInputVariables() }} -->
            <h4>
              Option 1: Save this run for comparison
            </h4>
            <p>
              Selecting this option means you’re happy with the results of your most recent run, and would like to save it.
            </p>
            <p>
              Saving for comparison means that you will be taken back to the beginning for the simulation, but with the ability to use the saved run as a new comparative baseline . This way you can perform more tests to see whether you can improve the region even further!
            </p>
            <p>
              <button
                class="btn btn-primary"
                @click="saveResult()"
              >
                Save
              </button>
            </p>
            <br><br>
          </div>
          <div class="text-body col-md-6">
            <h4>
              Option 2: Save this run and Submit the Results
            </h4>
            <p>
              Selecting this option means you’re happy with the results of your most recent run and don’t think you could improve the region any further!
            </p>
            <p>
              After selecting this option, you will be taken to another screen where you will be asked to provide some basic information. Your run along with the provided information will then be anonymously shared with Midlands Connect to help them see your preferences and choices.
            </p>
            <p>
              <button
                class="btn btn-primary"
                @click="openSubmitResults()"
              >
                Save &amp; submit
              </button>
            </p>
            <br><br>
          </div>
        </div>
      </div>
    </div>
    <SubmitResultModalComponent />
  </div>
</template>

<script>
import CovidStatus from "../components/CovidStatus";
import RunButtons from "../components/RunButtons";
import SubmitResultModalComponent from "../components/modals/SubmitResults";

export default {
  components: {
    CovidStatus,
    RunButtons,
    SubmitResultModalComponent,
  },
  data() {
    return {
      currentRun: this.$root.$data.sharedStorage.getCurrentRun(),
      sharedStorage: this.$root.$data.sharedStorage,
      isRunning: false,
    };
  },
  methods: {
    openSubmitResults() {
      this.$root.$data.eventHub.$emit("show-submit-results-modal");
    },
    saveResult() {
      this.sharedStorage.saveRun({ name: `Run on ${new Date().toLocaleString()}` });
      this.sharedStorage.startNewRun();
      document.location.href = "/";
    }
  },
};
</script>

<style lang="scss">
.lessons {
  .text-body {
    margin: 15px 15px 40px 15px;
    h4 {
      margin: 25px 0 15px 0;
    }
  }
}
</style>
